import { render, staticRenderFns } from "./RefundIcon.vue?vue&type=template&id=1444dea4"
import script from "./RefundIcon.vue?vue&type=script&lang=js"
export * from "./RefundIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports